import FilterSection from './components/FilterSection/FilterSection';
import GridSection from './components/GridSection/GridSection';

import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import classes from './bulkEditRoot.module.scss';
import { useBulkEditRoot } from './useBulkEditRoot.logic';

const BulkEditRoot = () => {
  const {
    editData,
    setEditData,
    setEditDataCopy,
    filterpayload,
    isDataLoading,
    setIsDataLoading,
    ndcNotesSet,
    ndcError,
    setNdcNotesSet,
    getForecastValue,
    setForecastValue,
    isRowEdited,
    isBtnEnabled,
    isNotesBtnEnabled,
    isSalveAllBtnEnabled,
    handleSingleSave,
    handleSaveAllEdited,
    ndcSaveLoading,
    isSaveAllLoading,
    isNotesLoading,
    notesData,
    isNoteSaving,
    getNotesData,
    handleAddNote,
    hasMore,
    nextPageLoading,
    loadMore,
    showCancelAlert,
    setShowCancelAlert,
    isRowsEdited,
    singleSaveModalVisibility,
    setSingleSaveModalVisibility,
    saveAllModalVisibility,
    setSaveAllModalVisibility,
    setNotesData,
    isNoteEdited,
    setIsNoteEdited,
    isNoteDeleted,
    setIsNoteDeleted,
    handleCopy,
    handleEditNote,
    handleDeleteNote,
    deletingNote,
    isNoteDeleting,
    isDeleteClicked,
    setIsDeleteClicked,
    setDeletingNote,
    initialLoading,
    handleApplyFilter,
    handleCancelButtonClick,
    expandedRows,
    toggleRowExpansion,
    isRowExpanded,
    getBaselineValue,
    getModeState,
    handleModeToggle,
    handleConceptSort,
    getRowStatus,
  } = useBulkEditRoot();
  const navigate = useNavigate();

  return (
    <div className={classes.container}>
      <FilterSection
        filterpayload={filterpayload}
        isDataLoading={isDataLoading || nextPageLoading}
        areChangesToBeSaved={isRowsEdited()}
        handleApplyFilters={handleApplyFilter}
      />
      <GridSection
        loading={isDataLoading}
        setIsDataLoading={setIsDataLoading}
        data={editData}
        setData={setEditData}
        initialLoading={initialLoading}
        handleCopy={handleCopy}
        setCopyData={setEditDataCopy}
        getForecastValue={getForecastValue}
        setForecastValue={setForecastValue}
        isRowEdited={isRowEdited}
        isBtnEnabled={isBtnEnabled}
        isNotesBtnEnabled={isNotesBtnEnabled}
        isSalveAllBtnEnabled={isSalveAllBtnEnabled}
        notesSet={ndcNotesSet}
        setNoteSet={setNdcNotesSet}
        ndcError={ndcError}
        handleSingleSave={handleSingleSave}
        handleSaveAllEdited={handleSaveAllEdited}
        ndcSaveLoading={ndcSaveLoading}
        isSaveAllLoading={isSaveAllLoading}
        isNotesLoading={isNotesLoading}
        notesData={notesData}
        setNotesData={setNotesData}
        isNoteEdited={isNoteEdited}
        setIsNoteEdited={setIsNoteEdited}
        isNoteDeleted={isNoteDeleted}
        setIsNoteDeleted={setIsNoteDeleted}
        isNoteSaving={isNoteSaving}
        getNotesData={getNotesData}
        handleAddNote={handleAddNote}
        handleEditNote={handleEditNote}
        handleDeleteNote={handleDeleteNote}
        deletingNote={deletingNote}
        isNoteDeleting={isNoteDeleting}
        isDeleteClicked={isDeleteClicked}
        setIsDeleteClicked={setIsDeleteClicked}
        setDeletingNote={setDeletingNote}
        hasMore={hasMore}
        loadMore={loadMore}
        nextPageLoading={nextPageLoading}
        singleSaveModalVisibility={singleSaveModalVisibility}
        setSingleSaveModalVisibility={setSingleSaveModalVisibility}
        saveAllModalVisibility={saveAllModalVisibility}
        setSaveAllModalVisibility={setSaveAllModalVisibility}
        expandedRows={expandedRows}
        toggleRowExpansion={toggleRowExpansion}
        isRowExpanded={isRowExpanded}
        getBaselineValue={getBaselineValue}
        handleConceptSort={handleConceptSort}
        getModeState={getModeState}
        handleModeToggle={handleModeToggle}
        getRowStatus={getRowStatus}
        filterpayload={filterpayload}
      />
      <div className={classes.btnContainer}>
        <Button className={classes.cancelBtn} onClick={handleCancelButtonClick}>
          Cancel
        </Button>
      </div>

      <ConfirmationModal
        visibility={showCancelAlert}
        modalHeading="Confirmation"
        modalContent="You have not saved changes, are you sure you want to cancel ?"
        loading={false}
        confirmLabel="Confirm"
        handleCancel={() => setShowCancelAlert(false)}
        handleConfirm={() => {
          navigate(-1);
          setShowCancelAlert(false);
        }}
      />
    </div>
  );
};

export default BulkEditRoot;
